import * as React from 'react';
import { useEffect, useState } from 'react';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import { Event, getAvailableTimeSlots } from '../../../../../api/Property';
import { getTodaysDateString } from '../../../../../utilities/Utils';
import FormDatePicker from '../../../../common/form/DatePicker';
import * as moment from 'moment';
import { momentDateFormat } from '../../../../../utilities/formatting';
import FormSelectLabeled from '../../../../common/form/SelectLabeled';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { MyToursPageTourDto, updateTour } from '../../../../../api/MyTours';

interface Props {
    propertyName: string;
    propertyId: number;
    tour: MyToursPageTourDto;
    guestCardGuid: string;
    isOpen: boolean;
    close: () => void;
    setTourTime: (timeslot: Event) => void;
}

const TourReschedulePopup = (props: Props) => {
    const formatDate = (date: string) => moment(date).utc().format(momentDateFormat);

    const tourEvent: Event = {
        startDateTime: props.tour.tourStart,
        endDateTime: props.tour.tourEnd,
        isTourNow: props.tour.isTourNow
    };

    const [availableTimeSlots, setAvailableTimeSlots] = useState<Event[]>([]);
    const [selectedDate, setSelectedDate] = useState(
        formatDate(props.tour.tourStart) || getTodaysDateString()
    );
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(tourEvent);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const getTimeSlots = async (date: string) => {
        setLoading(true);
        setAvailableTimeSlots([]);
        let result = await getAvailableTimeSlots(props.propertyId, date);

        if (result.success && result.data) {
            setAvailableTimeSlots(result.data);
        }
        setLoading(false);
    };

    const handleReschedule = async () => {
        setLoading(true);

        let result = await updateTour(props.tour.tourGuid, selectedTimeSlot);

        if (result.success) {
            setLoading(false);
            props.close();
            props.setTourTime(selectedTimeSlot);
        } else {
            setErrorMessage(result.error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.isOpen) {
            getTimeSlots(selectedDate);
        }
    }, [selectedDate, props.isOpen]);

    return (
        <Modal isOpen={props.isOpen} centered={true}>
            <LoadingOverlay show={loading} inBootstrapColumn={false} />
            <FormValidationDisplay errorMessage={errorMessage} />
            <ModalBody className="reschedule-modal">
                <p className="reschedule-popup-title">Reschedule Tour</p>
                <p className="reschedule-help-text">
                    Your tour was scheduled for the following date and time. To reschedule, select a
                    new date and time below.
                </p>
                <p className="reschedule-property-name">{props.propertyName}</p>
                <p className="reschedule-popup-tour-date">
                    {moment(props.tour.tourStart).format('MMMM DD, YYYY')}
                </p>
                <p>{`${moment(props.tour.tourStart).format('h:mm')} - ${moment(
                    props.tour.tourEnd
                ).format('h:mm A')}`}</p>

                <div>
                    <FormDatePicker
                        inputProps={{
                            id: 'requested-date',
                            name: 'date',
                            value: selectedDate,
                            required: true
                        }}
                        labelProps={{
                            labelText: 'Date',
                            invalidText: 'Please select a valid date'
                        }}
                        onChange={(_, newValue) => setSelectedDate(newValue)}
                    />
                    <FormSelectLabeled
                        selectProps={{
                            id: 'requested-time',
                            name: 'timeslot',
                            placeholder:
                                availableTimeSlots.length > 0
                                    ? 'Select a time slot'
                                    : 'No times available',
                            value: availableTimeSlots.indexOf(selectedTimeSlot) || 0,
                            required: true
                        }}
                        selectOptions={availableTimeSlots.map((timeslot, index) => ({
                            value: index,
                            label: timeslot.isTourNow? `Tour Now ( Ends at - ${moment(
                                timeslot.endDateTime
                            ).format('h:mm A')} )`: `${moment(timeslot.startDateTime).format('h:mm A')} - ${moment(
                                timeslot.endDateTime
                            ).format('h:mm A')}`
                        }))}
                        labelProps={{
                            labelText: 'Time',
                            invalidText: 'Please select a time slot'
                        }}
                        onChange={(_, newValue) =>
                            setSelectedTimeSlot(availableTimeSlots[newValue as number])
                        }
                    />
                </div>
                <Row>
                    <Col className="reschedule-popup-buttons">
                        <button className="reschedule-popup-cancel" onClick={() => props.close()}>
                            Cancel
                        </button>
                        <button
                            className="reschedule-popup-reschedule"
                            onClick={() => handleReschedule()}
                        >
                            Reschedule
                        </button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default TourReschedulePopup;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/allTours/TourReschedulePopup.tsx